import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormArray,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { Specialite } from 'src/app/shared/models/specialite';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION,
	FORMATION_DURATION_MAX,
	MISSION_TYPE_REUNION_TYPE,
	MISSION_TYPE_QUALIFICATION_DEMAND,
	MISSION_TYPE_PRESCRIPTION
} from 'src/app/core/services/constant/constants.service';
import { DataStorageService } from 'src/app/core/services/dataStorage/data-storage.service';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Mission } from 'src/app/shared/models/mission/mission';
import { User } from 'src/app/shared/models/security/user';
import { Router } from '@angular/router';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Authority } from 'src/app/shared/models/security/authority';
import { PreparationTime } from 'src/app/shared/models/quota/preparation-time';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { OverlappingResponse } from 'src/app/shared/models/api-response/overlapping-response';
import { ResolveConflictModalComponent } from 'src/app/shared/components/resolve-conflict-modal/resolve-conflict-modal.component';
import { SlotStatus } from 'src/app/shared/models/services-aide-emploi/slot';
import { forkJoin } from 'rxjs';
import { ListAvailableEmployeesComponent } from '../../list-available-employees/list-available-employees.component';
import { CenterDepartment } from 'src/app/shared/models/center-department';
import { Parcours } from 'src/app/shared/models/services-aide-emploi/parcours';

@Component({
	selector: 'app-formations-modal-ajout-form',
	templateUrl: './formations-modal-ajout-form.component.html',
	styleUrls: ['./formations-modal-ajout-form.component.scss']
})
export class FormationsModalAjoutFormComponent implements OnInit {
	LABEL_BENEFICIAIRE: string;
	LABEL_INTERVENANT_CAPITALIZED_PLURALIZED: string;
	LABEL_INTERVENANT: string;
	LABEL_INTERVENTION: string;
	LABEL_INTERVENTION_CAPITALIZED_PLURALIZED: string;
	MIN_WORKING_HOUR = this.facade.dataStorageService.getParamMinDay();
	minWorkingHourAsDate = new Date(
		new Date().setHours(this.MIN_WORKING_HOUR, 0, 0, 0)
	);
	MAX_WORKING_HOUR = this.facade.dataStorageService.getParamMaxDay();
	maxWorkingHourAsDate = new Date(
		new Date().setHours(this.MAX_WORKING_HOUR, 0, 0, 0)
	);
	MAX_DURATION = this.numberToHoursNumber(FORMATION_DURATION_MAX);
	minDurationAsDate = new Date(new Date().setHours(0, 0, 0, 0));

	user: User;
	Authority = Authority;

	listMissionPlace: MissionPlace[];
	listMissionType: MissionType[];
	listCareSpecialty: Specialite[];
	listBeneficiaire: Beneficiaire[];
	listParcours: Parcours[];
	listBeneficiaireMapped = []; // list pour le typeahead sous forme {name:nom_beneficiaire,object:beneficiaire}
	listParcoursMapped = []; 
	listEmployee: Employee[] = [];
	listEmployeeMapped = []; // list pour le typeahead sous forme {name:nom_employee,object:employee}

	isProjectManager: boolean = false;
	isProfessionnelSAE: boolean = false;
	isProfessionnelTerrain: boolean = false;

	readyTimeDate = new Date(new Date().setHours(7, 0, 0, 0));
	dueTimeDate = new Date(new Date().setHours(10, 0, 0, 0));

	durationDate = new Date(new Date().setHours(0, 30, 0, 0));

	isSESSAD =
		(JSON.parse(sessionStorage.getItem('USER')) as User)?.employee
			?.serviceCenter?.type === 1;
	isSAAD =
		(JSON.parse(sessionStorage.getItem('USER')) as User)?.employee
			?.serviceCenter?.type === 2;
	isSSIAD =
		(JSON.parse(sessionStorage.getItem('USER')) as User)?.employee
			?.serviceCenter?.type === 3;
	isSAE =
		(JSON.parse(sessionStorage.getItem('USER')) as User)?.employee
			?.serviceCenter?.type === 4;
	listCompetences;
	selectedCompetences = [];

	formAjout = new FormGroup(
		{
			date: new FormControl(
				this.facade.dataStorageService.getParam('missionStartDate')
					? new Date(
							this.facade.dataStorageService.getParam('missionStartDate')
					  )
					: this.facade.dataStorageService.getParam('storedCalendarWeeknumber')
					? this.dateUtils.getDateOfISOWeek(
							this.facade.dataStorageService.getParam(
								'storedCalendarWeeknumber'
							),
							this.facade.dataStorageService.getParam(
								'storedCalendarYearnumber'
							)
								? this.facade.dataStorageService.getParam(
										'storedCalendarYearnumber'
								  )
								: new Date().getFullYear()
					  )
					: new Date(),
				Validators.required
			),
			readyTime: new FormControl(this.readyTimeDate, [
				Validators.required,
				workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
			]),
			dueTime: new FormControl(this.dueTimeDate, [
				Validators.required,
				workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
			]),
			duration: new FormControl(this.durationDate),
			competences: new FormControl(''),
			missionPlace: new FormControl('', this.createMissionPlaceValidator()),
			missionType: new FormControl('', Validators.required),
			careSpecialty: new FormControl(''),
			beneficiaire: new FormControl(''),
			parcoursId: new FormControl(''),
			notes: new FormControl('', Validators.maxLength(1023)),
			isMissionPlaceBeneficiaireAddress: new FormControl(false),
			isRemote: new FormControl(false),
			remind: new FormControl(true),
			employee: new FormControl(''),
			preparationTimePercentage: new FormControl(25, Validators.required),
			nombreIntervenants: new FormControl(1, Validators.required),
			centerDepartment: new FormControl(null),
			participants: new FormArray([])
		},
		{
			validators: [
				durationValidator(this.MAX_DURATION),
				missionPlaceRequiredOnMissionType(this.isSESSAD),
				beneficiaireRequiredOnMissionType
			]
		}
	);



	isTWActive: boolean;

	isReunion = false;
	messageInviteIntervenantParticipant = 'Entrez un intervenant à ajouter';

	isEventRecurring: boolean;
	datesList: Date[] = [];

	selectedMissionPlace: MissionPlace = null;
	selectedMissionType: MissionType = null;
	selectedCareSpecialty: Specialite = null;
	selectedBeneficiaire: Beneficiaire = null;
	selectedParcours: Parcours = null;
	selectedIntervenants: Employee = null;

	selectedEmployeesForMission: Employee[] = [];
	selectedParticipant: string = '';

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	/**
	 * Noms des types de mission (Formation longue, réunion, etc)
	 */
	missionTypeName = MissionTypeName;

	// Pour l'affichage des temps de préparation possible dans le formulaire
	preparationTimeList: PreparationTime[] = [];

	bsModalResolveConflict: BsModalRef;

	/* MISSION EN GROUPE */
	maxIntervenantSelectableForMission: number = 3; // nombre maximal d'intervenant pour la mission donnée
	numberOfIntervenantsSelected: number = 0; // nombre d'intervenant sélectionné dans le listing
	isNumberOfIntervenantSelectedValid: boolean = true; // si le nombre d'intervenant sélectioné est incorrect
	isNumberOfIntervenantInputValid: boolean = true; // si le nombre d'intervenant sélectioné est supérieur au nombre écrit

	// SAE
	parameters: {
		date: Date;
		startTime: number;
		endTime: number;
		missionType: string;
		skill: string;
		specialty?: string;
		id?: string; // prescriberRequestId
		beneficiaireId?: number; // ocashe beneficiaire id
	};

	isAPrescription: boolean;

	centerDepartments: CenterDepartment[];
	selectedCenterDepartment: CenterDepartment = null;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private dataStorageService: DataStorageService,
		private router: Router,
		private dateUtils: DateUtils,
		private bsModalService: BsModalService
	) {}

	/**
	 * Initializes the component and performs necessary setup tasks.
	 * Retrieves data from services, sets initial values for form controls, and filters data based on certain conditions.
	 */
	ngOnInit(): void {
		// Retrieve the list of competences from the data storage service
		this.facade.careSkillService
			.getAllCareSkills()
			.subscribe((careSkills) => (this.listCompetences = careSkills));

		// Determine if the TW (Travailleur Social) feature is active based on the user's service center type
		this.isTWActive = this.isSSIAD || this.isSAAD;

		// Determine if the user is a project manager, professionnel SAE, or professionnel terrain based on data from the data storage service
		this.isProjectManager = this.facade.dataStorageService.isProjectManager();
		this.isProfessionnelSAE =
			this.facade.dataStorageService.isProfessionnelSAE();
		this.isProfessionnelTerrain =
			this.facade.dataStorageService.isProfessionnelTerrain();

		// Remove the 'duration' form control if the TW feature is not active
		if (!this.isTWActive) {
			this.formAjout.removeControl('duration');
		}

		// Initialize labels for the component
		this.initLabels();

		// Retries datas
		forkJoin({
			specialties: this.facade.specialiteService.getAllSpecialites(),
			parcours: this.facade.parcoursService.getParcours(),
			beneficiaires: this.facade.beneficiaireService.getBeneficiairesMinimal(),
			missionPlaces: this.facade.missionPlaceService.getMissionPlaces(),
			missionTypes: this.facade.missionTypeService.getAllMissionTypes(),
			centerDepartments:
				this.facade.centerDepartmentService.getAllCenterDepartmentsForUserCenter()
		}).subscribe(
			({
				specialties,
				parcours,
				beneficiaires,
				missionPlaces,
				missionTypes,
				centerDepartments
			}) => {
				this.listCareSpecialty = specialties;
				this.listParcours = parcours;
				this.listParcoursMapped = parcours.flatMap((e) => {
					return { name: e.idDemandDH + ' | ' + e.beneficiaire.firstName +
						 ' ' + e.beneficiaire.lastName, object: e };
				});
				this.listBeneficiaire = beneficiaires;
				this.listBeneficiaireMapped = beneficiaires.flatMap((e) => {
					return { name: e.firstName + ' ' + e.lastName, object: e };
				});
				this.listMissionPlace = missionPlaces;
				this.listMissionType = missionTypes;
				// Filter the list of mission types based on the user's role as a project manager
				if (this.isProjectManager) {
					this.listMissionType = this.listMissionType.filter(
						(missionType) => missionType.type !== MISSION_TYPE_REUNION_TYPE
					);
				}
				if (this.isSAE) {
					this.initFormForSAE();
				}
				this.centerDepartments = centerDepartments;
			}
		);

		// Retrieve the list of employees from the employee service
		this.facade.employeeService.getAllActiveEmployees().subscribe((d) => {
			this.listEmployee = d;

			// Sort the list of employees by first name
			this.listEmployee.sort((emp1, emp2) => {
				return emp1.firstName.localeCompare(emp2.firstName);
			});

			// If the user is a SSIAD, filter the list of employees based on their care skills
			if (this.isSSIAD) {
				this.listEmployee = this.listEmployee?.filter((employee) => {
					return (
						hasEmployeeSkill(employee, CompetencesElementaires.INFIRMIER) ||
						hasEmployeeSkill(employee, CompetencesElementaires.AIDESOIGNANT)
					);
				});
			}

			// Map the list of employees to a new array for display purposes
			this.listEmployeeMapped = this.listEmployee?.flatMap((e) => {
				return { name: e.firstName + ' ' + e.lastName, object: e };
			});
		});

		// Retrieve the user object from the data storage service
		this.user = this.facade.dataStorageService.getUser();

		// Set the selected employees for the mission to an empty array
		this.selectedEmployeesForMission = [];

		// Retrieve the preparation time list for the center from the center service
		this.facade.centerService
			.getPreparationTimeForCenter()
			.subscribe((preparationTimeList: PreparationTime[]) => {
				this.preparationTimeList = preparationTimeList;

				// Set the default value for the preparation time percentage form control
				this.formAjout
					.get('preparationTimePercentage')
					.setValue(this.preparationTimeList[0].time);
			});
	}

	initLabels() {
		this.LABEL_BENEFICIAIRE = this.dataStorageService.getLabel(
			PARAM_LABEL_BENEFICIAIRE
		);
		this.LABEL_INTERVENANT =
			this.dataStorageService.getLabel(
				PARAM_LABEL_INTERVENANT
			);
		this.LABEL_INTERVENANT_CAPITALIZED_PLURALIZED =
			this.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.LABEL_INTERVENTION = this.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.LABEL_INTERVENTION_CAPITALIZED_PLURALIZED =
			this.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);
	}

	typeaheadCenterDepartmentOnSelect(event: TypeaheadMatch): void {
		this.selectedCenterDepartment = event.item as CenterDepartment;
	}

	centerDepartmentsKeyUp(e: any) {
		if (
			this.selectedCenterDepartment &&
			this.selectedCenterDepartment.name +
				' ' +
				this.selectedCenterDepartment.name !=
				e.value
		) {
			this.selectedCenterDepartment = null;
		}
	}

	initFormForSAE() {
		// SAE
		if (this.parameters) {
			this.isAPrescription =
				this.parameters.missionType === MissionTypeName.PRESCRIPTION;
			if (this.parameters.date) {
				this.formAjout.get('date').setValue(new Date(this.parameters.date));
			}
			if (this.parameters.startTime) {
				this.formAjout
					.get('readyTime')
					.setValue(
						this.dateUtils.getFullDateFromDateAndMinutes(
							new Date(this.parameters.date),
							this.parameters.startTime
						)
					);
			}
			if (this.parameters.endTime) {
				this.formAjout
					.get('dueTime')
					.setValue(
						this.dateUtils.getFullDateFromDateAndMinutes(
							new Date(this.parameters.date),
							this.parameters.endTime
						)
					);
			}
			if (this.parameters.missionType) {
				this.selectedMissionType = this.listMissionType.find(
					(type) => type.type === this.parameters.missionType
				);
				this.formAjout
					.get('missionType')
					.setValue(this.selectedMissionType.type);
				this.selectCareSkillFromMissionTypeSAE();
			}
			if (this.parameters.skill) {
				const competenceToPush = CompetencesElementaires[this.parameters.skill];
				if (
					!!competenceToPush &&
					!this.selectedCompetences.includes(competenceToPush)
				) {
					this.selectedCompetences.push(competenceToPush);
				}
			}
			if (this.parameters.specialty) {
				this.selectedCareSpecialty = this.listCareSpecialty.find(
					(s) => s.name === this.parameters.specialty
				);
				this.formAjout
					.get('careSpecialty')
					.setValue(this.selectedCareSpecialty.name);
			}
			if (this.parameters.beneficiaireId) {
				//il s'agit de l'id du bénéficiaire sur ocashe. on lance une requête pour retrouver le bénéficiaire correspondant dans la base isy
				this.facade.beneficiaireService
					.getBeneficiaireIdByOcasheId(this.parameters.beneficiaireId)
					.subscribe({
						next: (beneficiaireId) => {
							this.selectedBeneficiaire = this.listBeneficiaire.find(
								(b) => b.id === beneficiaireId
							);
							const beneficiaireMapped = this.listBeneficiaireMapped.find(
								(e) => e.object.id === beneficiaireId
							);
							this.formAjout
								.get('beneficiaire')
								.setValue(beneficiaireMapped.name);
						},
						error: (e) => this.logger.error(e)
					});
			}
			if (this.isAPrescription) {
				this.formAjout.controls['date']['disable']({
					onlySelf: true,
					emitEvent: false
				});
				this.formAjout.controls['readyTime']['disable']({
					onlySelf: true,
					emitEvent: false
				});
				this.formAjout.controls['dueTime']['disable']({
					onlySelf: true,
					emitEvent: false
				});
				this.formAjout.controls['missionType']['disable']({
					onlySelf: true,
					emitEvent: false
				});
				this.formAjout.controls['missionPlace']['disable']({
					onlySelf: true,
					emitEvent: false
				});
				this.formAjout.get('isRemote').setValue(true);
			}
		}
	}

	// si true : affiche dans le template la possibilité de cocher le domicile du bénéficiaire
	displayBeneficiaireLocation(): boolean {
		return (
			!this.isReunion &&
			(this.isSESSAD || this.isSAE) &&
			!!this.selectedBeneficiaire &&
			!this.isRemote
		);
	}

	displayIntervenantsSelection(): boolean {
		return !!this.selectedIntervenants;
	}

	setInfosToMission(intervention: MissionRequest, listMission: Mission[]) {
		intervention.careSkills = [...this.selectedCompetences];

		if (this.isSESSAD || this.isSAE) {
			intervention.missionPlace = this.selectedMissionPlace;
			intervention.preparationTimePercentage = this.formAjout.get(
				'preparationTimePercentage'
			).value;
		}
		intervention.beneficiaire = this.selectedBeneficiaire;
		intervention.parcoursId = this.selectedParcours.idDemandDH;
		intervention.missionType = this.selectedMissionType;
		if (this.selectedCareSpecialty) {
			intervention.careSpecialty = this.selectedCareSpecialty;
		} else {
			//FIXME: Voir avec le back pour ne pas écrire ça en dur
			intervention.careSpecialty = { id: 0, name: 'Sans' };
		}
		intervention.notes = this.formAjout.get('notes').value;
		intervention.nombreIntervenant =
			this.formAjout.get('nombreIntervenants').value;

		const mission = new Mission();
		mission.plannedStart = intervention.readyTime;
		mission.plannedEnd = intervention.dueTime;
		mission.missionRequest = intervention;
		if (this.isProjectManager || this.isProfessionnelSAE) {
			mission.planner = this.user.employee;
		}

		this.logger.log('mission : ', mission);
		listMission.push(mission);
	}

	openResolveConflictModal(overlappingResponse: OverlappingResponse) {
		const initialState: ModalOptions = {
			initialState: {
				mission: overlappingResponse.mission,
				overlappingResponse,
				initialEmployee: this.selectedEmployeesForMission[0],
				selectedCalendarDate: null,
				getData: null
			},
			class: 'modal-lg'
		};
		this.bsModalResolveConflict = this.bsModalService.show(
			ResolveConflictModalComponent,
			initialState
		);
	}

	selectEmployee(employee: Employee) {
		this.selectedEmployeesForMission.push(employee);
		this.participants.push(
			new FormGroup({
				isMissionPlaceIntervenantAddress: new FormControl(false)
			})
		);
	}

	onSubmit() {
		if (!this.validatePreconditions()) return;

		const listMission: Mission[] = this.prepareMissionList();

		console.log(listMission);

		if (this.parameters?.missionType === MISSION_TYPE_PRESCRIPTION) {
			this.postPrescription(listMission[0]);
		} else if (this.shouldPostMultipleEmployees()) {
			this.postMultipleEmployees(listMission);
		} else if (this.shouldForceAssignMission()) {
			this.forceAssignMission(listMission);
		} else {
			this.postMissions(listMission);
		}
	}

	validatePreconditions(): boolean {
		if (
			!this.isReunion &&
			this.formAjout.get('nombreIntervenants').value <
				this.numberOfIntervenantsSelected
		) {
			this.isNumberOfIntervenantInputValid = false;
			return false;
		}

		if (this.selectedMissionType.type === MissionTypeName.MISSION_ANNEXE) {
			if (this.selectedBeneficiaire === null) {
				this.facade.toastService.createErrorToast(
					'Ce type de mission nécessite un bénéficiaire.'
				);
				return false;
			}
		}
		return true;
	}

	prepareMissionList(): Mission[] {
		const listMission: Mission[] = [];
		const datesToProcess = this.datesList.length
			? this.datesList
			: [this.formAjout.get('date').value];

		datesToProcess.forEach((date) => {
			const intervention = new MissionRequest();
			intervention.readyTime = this.timeToNumber(
				this.formAjout.get('readyTime').value
			);
			intervention.dueTime = this.timeToNumber(
				this.formAjout.get('dueTime').value
			);
			intervention.duration = this.isTWActive
				? this.timeToNumber(this.formAjout.get('duration').value)
				: intervention.dueTime - intervention.readyTime;
			intervention.date = new Date(
				date.getFullYear(),
				date.getMonth(),
				date.getDate()
			);
			if (this.isSESSAD || this.isSAE) {
				intervention.missionPlace = this.selectedMissionPlace;
				intervention.preparationTimePercentage = this.formAjout.get(
					'preparationTimePercentage'
				).value;
			}
			intervention.remote = this.isRemote;
			intervention.reminderStatus =
				this.formAjout.get('remind').value === true ? 'ACTIVE' : 'INACTIVE';
			intervention.centerDepartment = this.selectedCenterDepartment;
			this.setInfosToMission(intervention, listMission);
		});
		return listMission;
	}

	shouldPostMultipleEmployees(): boolean {
		return (
			this.selectedMissionType.type === MissionTypeName.REUNION ||
			this.formAjout.get('nombreIntervenants').value > 1
		);
	}

	buildParticipantsBooleanMap(): Map<number, boolean> {
		const map = new Map<number, boolean>();
	  
		this.selectedEmployeesForMission.forEach((emp, i) => {
		  const isFromHome =
			this.participants.at(i).get('isMissionPlaceIntervenantAddress')?.value ?? false;
	  
		  map.set(emp.id, isFromHome);
		});
	  
		return map;
	  }
	  

	postMultipleEmployees(listMission: Mission[]) {
		// const empIdListStr =
		// 	this.selectedEmployeesForMission.map((emp) => emp.id).join('_') || '0';
			const employeeMissionMap = this.buildParticipantsBooleanMap();
			console.log(employeeMissionMap);
			console.log(listMission)
		this.facade.missionService
			.postMissionWithMultipleEmployee(listMission, employeeMissionMap)
			.subscribe({
				next: this.handleMissionResponse.bind(this),
				error: this.handleError.bind(this)
			});
	}

	shouldForceAssignMission(): boolean {
		return (
			this.formAjout.get('nombreIntervenants').value === 1 &&
			this.selectedEmployeesForMission.length === 1
		);
	}

	forceAssignMission(listMission: Mission[]) {

		this.facade.missionService
			.postMissionsForceAffectation(
				listMission,
				this.selectedEmployeesForMission[0].id,
				this.participants.at(0).get('isMissionPlaceIntervenantAddress')?.value ?? false
			)
			.subscribe({
				next: this.handleMissionResponse.bind(this),
				error: this.handleError.bind(this)
			});
	}

	postMissions(listMission: Mission[]) {
		this.facade.missionService.postMissions(listMission).subscribe({
			next: this.handleMissionResponse.bind(this),
			error: this.handleError.bind(this)
		});
	}

	postPrescription(mission: Mission) {
		const prescriberRequestId = this.parameters.id;
		if (this.shouldForceAssignMission()) {
			this.facade.missionService
				.postPrescriptionWithAssignation(
					mission,
					prescriberRequestId,
					this.selectedEmployeesForMission[0].id
				)
				.subscribe({
					next: this.handleMissionResponse.bind(this),
					error: this.handleError.bind(this)
				});
		} else {
			this.facade.missionService
				.postPrescription(mission, prescriberRequestId)
				.subscribe({
					next: this.handleMissionResponse.bind(this),
					error: this.handleError.bind(this)
				});
		}
	}

	handleMissionResponse(response: any) {
		this.logger.log('Mission processing success: ', response);
		this.isValidateButtonClicked = false;
		this.closeModal();
	}

	handleError(error: any) {
		this.logger.error('Mission processing failed: ', error);
		this.facade.toastService.createHttpErrorToast(
			error.error.response
				? error.error.response
				: 'Une erreur est survenue lors de la création de la mission',
			error.status
		);
		this.isValidateButtonClicked = false;
		this.closeModal();
	}

	closeModal() {
		this.bsModalRef.hide();
		this.router.navigate(['/gestion/formations/list']);
	}

	updatePrescriberRequestStatus(status: SlotStatus) {
		if (
			this.isSAE &&
			this.selectedMissionType.type === MISSION_TYPE_PRESCRIPTION &&
			this.parameters.id
		) {
			this.facade.prescriberService
				.updateAppointmnentStatus(this.parameters.id, SlotStatus[status])
				.subscribe({
					next: (s) => {
						this.logger.info('status updated !');
					},
					error: (e) => {
						this.logger.info('status not updated !');
					}
				});
		}
	}

	shouldDisplayBeneficiaire() {
		if (this.isReunion) {
			return false;
		} else if (
			this.isSAE &&
			this.selectedMissionType?.type === MISSION_TYPE_PRESCRIPTION
		) {
			return false;
		} else {
			return true;
		}
	}

	shouldSubmitButtonBeDisabled() {
		return (
			!this.formAjout.valid ||
			!this.selectedMissionType ||
			this.isAlertAddressBeneficiaireNeeded() ||
			this.isValidateButtonClicked ||
			(!this.selectedMissionPlace &&
				!this.isRemote &&
				!this.isMissionPlaceBeneficiaireAddress)
		);
	}

	isBeneficiaireAddressEqualsToCenterAddress() {
		return (
			this.selectedBeneficiaire.address.label ===
			this.dataStorageService.getServiceCenter().address.label
		);
	}

	isIntervenantAddressEqualsToCenterAddress() {
		return (
			this.selectedIntervenants.address.label ===
			this.dataStorageService.getServiceCenter().address.label
		);
	}

	isAlertAddressBeneficiaireNeeded() {
		return (
			this.formAjout.get('nombreIntervenants').value === 1 &&
			this.isMissionPlaceBeneficiaireAddress &&
			this.selectedBeneficiaire &&
			(!(
				this.selectedBeneficiaire.address.longitude &&
				this.selectedBeneficiaire.address.latitude
			) ||
				this.isBeneficiaireAddressEqualsToCenterAddress())
		);
	}

	isAlertAdressIntervenantNeeded(p:Employee, i:number) {
		/*return(
			this.isMissionPlaceBeneficiaireAddress &&
			this.selectedIntervenants &&
			(!(
					this.selectedIntervenants.address.longitude &&
					this.selectedIntervenants.address.latitude
				) ||
				this.isIntervenantAddressEqualsToCenterAddress())
		);*/
		const checked = this.isIntervenantDepartureChecked(i);
		const missingCoords = !(p.address?.longitude && p.address?.latitude);
		return !checked && missingCoords;
	}

	buildParticipantsPayload() {
		return this.selectedEmployeesForMission.map((p, i) => ({
			...p,
			isMissionPlaceIntervenantAddress:
				this.participants.at(i).get('isMissionPlaceIntervenantAddress')?.value ?? false
		}));
	}

	typeaheadMissionPlaceOnSelect(event: TypeaheadMatch): void {
		this.selectedMissionPlace = event.item as MissionPlace;
	}

	missionPlaceKeyUp(e: any) {
		if (
			this.selectedMissionPlace &&
			this.selectedMissionPlace.nameDisplay !== e.value
		) {
			this.selectedMissionPlace = null;
		}
	}

	selectCareSkillFromMissionTypeSAE() {
		if (this.isSAE) {
			this.selectedCompetences = [];
			if (
				this.selectedMissionType?.type === MISSION_TYPE_QUALIFICATION_DEMAND
			) {
				this.selectedCompetences.push(CompetencesElementaires.QUALIFICATION);
			} else if (this.selectedMissionType?.type === MISSION_TYPE_PRESCRIPTION) {
				this.selectedCompetences.push(CompetencesElementaires.PRESCRIPTION);
			} else {
				this.selectedCompetences.push(CompetencesElementaires.TERRAIN);
			}
		}
	}

	typeaheadTypeFormationOnSelect(event: TypeaheadMatch): void {
		this.selectedMissionType = event.item as MissionType;
		this.selectCareSkillFromMissionTypeSAE();

		if (this.selectedMissionType?.type === MISSION_TYPE_REUNION_TYPE) {
			this.isReunion = true;
			this.messageInviteIntervenantParticipant =
				'Entrez un participant à ajouter';
		} else {
			this.isReunion = false;
			this.messageInviteIntervenantParticipant =
				'Entrez un intervenant à ajouter';
		}

		this.selectedMissionPlace = null;
		this.formAjout.patchValue({ missionPlace: null }, { onlySelf: true });
		if (this.selectedMissionType.type === MissionTypeName.REUNION) {
			this.selectedBeneficiaire = null;
			this.formAjout.patchValue({ beneficiaire: null }, { onlySelf: true });
		} else {
			this.numberOfIntervenantsSelected = 0;
		}
		this.selectedEmployeesForMission = [];

		this.selectedCareSpecialty = null;
		this.formAjout.patchValue({ careSpecialty: null }, { onlySelf: true });

		this.maxIntervenantSelectableForMission =
			this.selectedMissionType.numberOfEmployee;
		this.checkValidityOfNumberOfEmployee();
	}

	typeFormationKeyUp(e: any) {
		if (this.selectedMissionType && this.selectedMissionType.type !== e.value) {
			this.selectedMissionType = null;
		}
	}

	typeaheadSpecialityOnSelect(event: TypeaheadMatch): void {
		this.selectedCareSpecialty = event.item as Specialite;
	}

	specialityKeyUp(e: any) {
		if (
			this.selectedCareSpecialty &&
			this.selectedCareSpecialty.name !== e.value
		) {
			this.selectedCareSpecialty = null;
		}
	}

	typeaheadBeneficiaireOnSelect(event: TypeaheadMatch): void {
		this.selectedBeneficiaire = event.item.object as Beneficiaire;
		if (this.isSESSAD) {
			// Seul cas où le bénéficiaire a une compétence
			this.selectedBeneficiaire.careSkills.forEach((c) =>
				this.selectedCompetences.push(CompetencesElementaires[c.name])
			);
		}
		this.formAjout.patchValue(
			{ beneficiaire: event.item.name },
			{ onlySelf: true }
		);
	}

	typeaheadParcoursOnSelect(event: TypeaheadMatch): void {
		this.selectedParcours = event.item.object as Parcours;
		this.selectedBeneficiaire = this.selectedParcours.beneficiaire;
    	this.selectedCenterDepartment = this.selectedParcours.service;

		this.formAjout.patchValue({
			beneficiaire: `${this.selectedParcours.beneficiaire.firstName} ${this.selectedParcours.beneficiaire.lastName}`,
			centerDepartment: this.selectedParcours.service.name
		});
		this.formAjout.patchValue(
			{ parcoursId: event.item.name },
			{ onlySelf: true }
		);
	}

	typeaheadIntervenantOnSelect(event: TypeaheadMatch): void {
		const empToInsert = event.item.object as Employee;
		this.selectedIntervenants= empToInsert;

	}

	beneficiaireKeyUp(e: any) {
		if (
			this.selectedBeneficiaire &&
			this.selectedBeneficiaire.firstName +
				' ' +
				this.selectedBeneficiaire.lastName !==
				e.value
		) {
			this.selectedBeneficiaire = null;
		}
	}

	parcoursKeyUp(e: any) {
		if (
			this.selectedParcours && this.selectedParcours.idDemandDH + 
			' | ' + this.selectedParcours.beneficiaire.firstName + ' ' + 
			this.selectedParcours.beneficiaire.lastName !== e.value
		) {
			this.selectedParcours = null;
		}
	}

	typeaheadEmployeeOnSelectForMissionWithMultipleEmployee(
		event: TypeaheadMatch
	): void {
		this.typeaheadIntervenantOnSelect(event);
		const empToInsert = event.item.object as Employee;
		if (
			this.selectedEmployeesForMission.findIndex(
				(emp) => emp.id === empToInsert.id
			) === -1
		) {
			this.selectedEmployeesForMission.push(empToInsert);
			this.participants.push(
				new FormGroup({
					isMissionPlaceIntervenantAddress: new FormControl(false)
				})
			);
			this.numberOfIntervenantsSelected += 1;
			this.checkValidityOfNumberOfEmployee();
		}
		this.selectedParticipant = '';
	}

	resetParticipantsReunion() {
		this.numberOfIntervenantsSelected = 1;
		this.selectedEmployeesForMission = [];
	}

	removeParticipant(p: Employee) {
		const idx = this.selectedEmployeesForMission.indexOf(p);
		if (idx > -1) {
			this.selectedEmployeesForMission.splice(idx, 1);
			this.participants.removeAt(idx);
		}

		this.selectedEmployeesForMission = this.selectedEmployeesForMission.filter(
			(emp) => emp.id !== p.id
		);
		this.numberOfIntervenantsSelected -= 1;
		this.checkValidityOfNumberOfEmployee();

	}

	/** Lecture de la valeur du checkbox pour l'intervenant i */
	isIntervenantDepartureChecked(i: number): boolean {
		return !!this.participants.at(i).get('isMissionPlaceIntervenantAddress')?.value;
	}

	checkValidityOfNumberOfEmployee() {
		this.isNumberOfIntervenantInputValid = true;

		// dans le cas d'une réunion, vérifier juste qu'on ait toujours au moins 1 intervenant
		if (this.selectedMissionType.type === MissionTypeName.REUNION) {
			if (this.formAjout.get('nombreIntervenants').value > 0) {
				this.isNumberOfIntervenantSelectedValid = true;
			} else {
				this.isNumberOfIntervenantSelectedValid = false;
			}
		}

		// Le nombre d'intervenant doit être positif et ne doit pas être supérieur au nombre max. d'intervenant
		// pour le type de mission sélectionée
		if (
			this.formAjout.get('nombreIntervenants').value >= 0 &&
			this.formAjout.get('nombreIntervenants').value <=
				this.maxIntervenantSelectableForMission
		) {
			this.isNumberOfIntervenantSelectedValid = true;
		} else {
			this.isNumberOfIntervenantSelectedValid = false;
		}
	}

	selectAllParticipants() {
		this.selectedEmployeesForMission = [...this.listEmployee];
	}

	resetMissionPlace() {
		if (this.isMissionPlaceBeneficiaireAddress || this.isRemote) {
			this.selectedMissionPlace = null;
			this.formAjout.patchValue({ missionPlace: null }, { onlySelf: true });
			if (this.isRemote) {
				this.formAjout.patchValue(
					{ isMissionPlaceBeneficiaireAddress: false },
					{ onlySelf: true }
				);
			}
		}
	}

	reload() {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([this.router.url]);
	}

	timeToNumber(date: Date): number {
		return date.getHours() * 60 + date.getMinutes();
	}

	numberToHoursNumber(temps: number): number {
		return Math.floor(temps / 60) || 0;
	}

	onSwitchRecurrencyChange() {
		this.isEventRecurring = !this.isEventRecurring;
	}

	updateDateList(dates: Date[]) {
		this.datesList = dates;
	}

	isCompetenceCheck(comp: CareSkill): boolean {
		return this.selectedCompetences?.some(
			(currComp) => currComp.id === comp.id
		);
	}

	isCompetencesElementaires(competence: CareSkill): boolean {
		return !!CompetencesElementaires[competence.name];
	}

	updateSelectedCompetence(e: any, comp: CareSkill) {
		/*if (this.isSAE) {
			this.selectedCompetences = [];
		}*/
		if (e.target.checked) {
			if (!this.selectedCompetences?.some((z) => z.id === comp.id)) {
				this.selectedCompetences.push(comp);
			}
		} else {
			if (this.selectedCompetences?.some((z) => z.id === comp.id)) {
				this.selectedCompetences = this.selectedCompetences.filter(
					(z) => z.id !== comp.id
				);
			}
		}
	}

	getMissionLocation() {
		if (this.isSAE && this.selectedBeneficiaire) {
			return this.isMissionPlaceBeneficiaireAddress
				? this.selectedBeneficiaire.address
				: this.selectedMissionPlace?.address;
		}
	}

	getCareSkills() {
		//2DO: corriger ce bugfix
		this.selectedCompetences = Array.from(new Set(this.selectedCompetences));

		return this.selectedCompetences;
	}

	get date() {
		return this.formAjout.get('date');
	}

	get dateAsDate() {
		return new Date(
			this.formAjout.get('date').value.getFullYear(),
			this.formAjout.get('date').value.getMonth(),
			this.formAjout.get('date').value.getDate()
		);
	}
	get dateAsDateMinusOneMonth() {
		return new Date(
			this.formAjout.get('date').value.getFullYear(),
			this.formAjout.get('date').value.getMonth() - 1,
			this.formAjout.get('date').value.getDate()
		);
	}
	get readyTime() {
		return this.formAjout.get('readyTime');
	}
	get dueTime() {
		return this.formAjout.get('dueTime');
	}
	get duration() {
		return this.formAjout.get('duration');
	}
	get missionPlace() {
		return this.formAjout.get('missionPlace');
	}
	get missionType() {
		return this.formAjout.get('missionType');
	}
	get careSpecialty() {
		return this.formAjout.get('careSpecialty');
	}
	get beneficiaire() {
		return this.formAjout.get('beneficiaire');
	}
	get parcoursId() {
		return this.formAjout.get('parcoursId');
	}

	get notes() {
		return this.formAjout.get('notes');
	}

	get isMissionPlaceBeneficiaireAddress() {
		return this.formAjout.get('isMissionPlaceBeneficiaireAddress').value;
	}

	get participants(): FormArray {
		return this.formAjout.get('participants') as FormArray;
	}

	get isMissionPlaceIntervenantAddress() {
		return this.formAjout.get('isMissionPlaceIntervenantAddress').value;
	}
	get isRemote() {
		return this.formAjout.get('isRemote').value;
	}

	get remind() {
		return this.formAjout.get('remind').value;
	}

	get nombreIntervenants() {
		return this.formAjout.get('nombreIntervenants');
	}

	get centerDepartment() {
		return this.formAjout.get('centerDepartment');
	}

	/**
	 * Validator vérifiant si la mission place écrite par l'utilisateur est correcte
	 * Si oui => on sélectionne automatiquement la mission place de la liste pour éviter que l'utilisateur ne la sélectionne après l'avoir tapé
	 * Si non => input invalid, on le fait savoir à l'utilisateur
	 * @returns null si pas d'erreur, l' {erreur:true} sinon
	 */
	createMissionPlaceValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			// value = ce qui est taper au clavier par l'utilisateur
			const value = control.value;

			if (!value) {
				return null;
			}

			const missionPlaceFoundFromUserInput = this.listMissionPlace.find(
				(missionPlace) => missionPlace.nameDisplay === value
			);

			let missionPlaceValid = true;
			if (!this.isMissionPlaceBeneficiaireAddress) {
				missionPlaceValid = missionPlaceFoundFromUserInput !== undefined;
			}

			// on sélectionne automatiquement la mission place de la liste
			if (missionPlaceValid) {
				this.selectedMissionPlace = missionPlaceFoundFromUserInput;
			}

			// si l'user a taper n'importe quoi, on lui affiche un message d'erreur
			return !missionPlaceValid ? { missionPlace: true } : null;
		};
	}
}

/**
 * Validator qui vérifie sur l'heure donner ce trouve dans un intervalle min-max
 * @param min Heure de début
 * @param max Heure de fin
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export function workingTimeValidator(min: number, max: number): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value;

		if (!value) {
			return null;
		}

		const hours = value.getHours();

		if (hours < min || hours > max) {
			return { outOfRange: true };
		}

		return null;
	};
}

/**
 * Validator vérifiant si l'heure de début est inférieure à l'heure de fin et si l'écart debut-fin est inférieur à un nombre d'heures donner
 * @param maxDuration Nombre d'heure maximum
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export function durationValidator(maxDuration: number): ValidatorFn {
	return (control: AbstractControl) => {
		const start = control.get('readyTime')?.value;
		const end = control.get('dueTime')?.value;
		if (start && end) {
			if (end.getTime() < start.getTime()) {
				return { endBeforeStart: true };
			}
			if (end.getHours() - start.getHours() > maxDuration) {
				return { tooManyHours: true };
			}
			return null;
		}
		return null;
	};
}

/**
 * Validator vérifiant si l'école doit être obligatoire (ce n'est pas le cas pour une réunion)
 * @param maxDuration Nombre d'heure maximum
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export function missionPlaceRequiredOnMissionType(
	isSESSAD: boolean
): ValidatorFn {
	return (control: AbstractControl) => {
		if (!isSESSAD) {
			return null;
		}

		const missionType = control.get('missionType').value;
		const missionPlace = control.get('missionPlace').value;
		if (control.get('isMissionPlaceBeneficiaireAddress').value) {
			return null;
		}

		return missionType !== MissionTypeName.REUNION &&
			missionType !== MissionTypeName.MISSION_ANNEXE &&
			(!missionPlace || missionPlace === '')
			? { missionPlaceRequired: true }
			: null;
	};
}

/**
 * Validator vérifiant si le bénéficiaire doit être obligatoire (ce n'est pas le cas pour une réunion)
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export const beneficiaireRequiredOnMissionType: ValidatorFn = (
	control: AbstractControl
): ValidationErrors | null => {
	const missionType = control.get('missionType').value;
	const beneficiaire = control.get('beneficiaire').value;

	return missionType !== MissionTypeName.REUNION &&
		missionType !== MissionTypeName.MISSION_ANNEXE &&
		missionType !== MISSION_TYPE_PRESCRIPTION &&
		(!beneficiaire || beneficiaire === '')
		? { beneficiaireRequired: true }
		: null;
};
